import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_PREFIX = 'CREDSYSTEM_';

class CredsystemLocalStorage {
  static async set(key: string, value: any): Promise<void> {
    if (value) {
      await AsyncStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
    }
  }

  static async multiSet(array: [string, string][]): Promise<void> {
    const formattedArray: [string, string][] = array.map((value) => [
      STORAGE_PREFIX + value[0],
      JSON.stringify(value[1]),
    ]);
    if (array) {
      await AsyncStorage.multiSet(formattedArray);
    }
  }

  static async remove(key: string): Promise<void> {
    AsyncStorage.removeItem(STORAGE_PREFIX + key);
  }

  static async multiRemove(keys: string[]): Promise<void> {
    const formattedKeys = keys.map((key) => STORAGE_PREFIX + key);
    AsyncStorage.multiRemove(formattedKeys);
  }

  static async get<T = any>(key: string): Promise<T | undefined> {
    const response = await AsyncStorage.getItem(STORAGE_PREFIX + key);
    if (response) {
      return await JSON.parse(response);
    }
    return undefined;
  }

  static async clear(): Promise<any> {
    const keys = await AsyncStorage.getAllKeys();
    await AsyncStorage.multiRemove(
      keys.filter((key) => key.startsWith(STORAGE_PREFIX))
    );
  }
}
export { CredsystemLocalStorage };
